import script from "./StockList.vue?vue&type=script&setup=true&lang=js"
export * from "./StockList.vue?vue&type=script&setup=true&lang=js"

import "./StockList.vue?vue&type=style&index=0&id=3060fa13&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3060fa13"]])

export default __exports__